import { AnyAction, Middleware } from "redux";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Localizable, LocalizableArgs } from "@com.mgmtp.a12.utils/utils-localization/lib/main";
import { LoggerFactory } from "@com.mgmtp.a12.utils/utils-logging";
import { WorkflowsActions } from "@com.mgmtp.a12.workflows/workflows-core/lib/actions";

import { createCustomNotificationAction } from "../../../app/actions";
import { localizableFromLocaleResources, RESOURCE_KEYS } from "../../../localization";

const logger = LoggerFactory.getLogger("workflow-feedback");

export const feedbackHandlingMiddleware: Middleware = api => next => action => {
	if (
		![
			WorkflowsActions.startProcess.done,
			WorkflowsActions.startProcess.failed,
			ActivityActions.save.done,
			WorkflowsActions.completeTask.failed,
			WorkflowsActions.assignTask.failed
		].some(a => a.match(action))
	) {
		return next(action);
	}

	const message = createMessageFor(action);

	if (!message) {
		return next(action);
	}

	api.dispatch(
		createCustomNotificationAction({
			message,
			severity: action.error ? "error" : "success"
		})
	);

	if (action.error) {
		logger.error(action.payload.error);
	}

	return next(action);
};

function createMessageFor(action: AnyAction): Localizable | undefined {
	const localizableArgs: LocalizableArgs = {
		processDefinitionName: { type: "plain", value: action.payload.params.processDefinition }
	};

	if (WorkflowsActions.startProcess.failed.match(action)) {
		return localizableFromLocaleResources(RESOURCE_KEYS.wf.notification.error.startprocess, localizableArgs);
	} else if (WorkflowsActions.completeTask.failed.match(action)) {
		return localizableFromLocaleResources(
			action.payload.error.name === "complete-task-outcome-unknown"
				? RESOURCE_KEYS.wf.notification.error.completetask
				: RESOURCE_KEYS.wf.notification.error.completetaskFailed,
			localizableArgs
		);
	} else if (WorkflowsActions.assignTask.failed.match(action)) {
		return localizableFromLocaleResources(RESOURCE_KEYS.wf.notification.error.assigntask, localizableArgs);
	}

	return undefined;
}
